export default (products, tourSearchModel) => {
    if (!products || !products.length) {
        return [];
    }

    return products.map((product) => ({
        startDate: tourSearchModel.getFromDate(product),
        price: product.get('product')?.get('priceWithOilTax') || product.get('product').get('price'),
        type: product.get('type'),
        operator: _.pick(product.get('product').get('operator'), 'id', 'name'),
        isExclusive: product.get('isExclusive'),
    }));
};